import { observable } from 'mobx'

export default class TxfConfigViewModel {
  @observable
  txfStripeCustomerId = undefined

  @observable
  autoVerificationConfig = 'SKIP_WHEN_POSSIBLE'

  activate(
    txfStripeCustomerId = undefined,
    autoVerificationConfig = 'SKIP_WHEN_POSSIBLE'
  ) {
    this.txfStripeCustomerId = txfStripeCustomerId
    this.autoVerificationConfig = autoVerificationConfig
  }

  toJSON() {
    return {
      stripe_customer_id: this.txfStripeCustomerId,
      auto_verification_config: this.autoVerificationConfig,
    }
  }
}
